

export const ISAUTH = "ISAUTH"

export const USER = 'USER';